import React, { ReactNode } from "react";
import { Box, Container } from "@mui/material";
import { Element } from "react-scroll";

type Props = {
  name: string;
  bg?: string;
  minHeight?: string;
  pt?: number | { xs?: number; sm?: number; md?: number };
  children: ReactNode;
};

const SectionWrapper: React.FC<Props> = ({
  name,
  bg,
  minHeight = "90vh",
  pt = 0,
  children,
}) => {
  return (
    <Element name={name}>
      <Box
        sx={{
          minHeight,
          display: "flex",
          alignItems: "center",
          pt,
          px: { xs: 2, sm: 0 },
          backgroundImage: bg
            ? `url(${bg})`
            : `radial-gradient(ellipse farthest-corner, white 20%, lightgray 80%)`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100%",
        }}
      >
        <Container maxWidth="lg">{children}</Container>
      </Box>
    </Element>
  );
};

export default SectionWrapper;
